import { connect } from 'react-redux';
import Assets from '../components/assets/Assets';

import * as assetSelectors from '../selectors/assetSelectors';
import * as assetConstants from '../constants/assets';
import * as tagsConstants from '../constants/tags';
import * as bucketSelectors from '../selectors/bucketSelectors';
import * as batchActionsSelectors from '../selectors/batchActionsSelectors';
import { ASSET_BATCH_ACTIONS } from '../enums/AssetActions';

const mapStateToProps = state => {
    const isAdmin = bucketSelectors.getIsCurrentUserAdminForCurrentBucket(state);

    return {
        application: assetSelectors.getApplication(state),
        assets: assetSelectors.getAssets(state),
        loading: assetSelectors.getLoading(state),
        loadingMore: assetSelectors.getLoadingMore(state),
        error: assetSelectors.getError(state),
        canLoadMore: assetSelectors.getCanLoadMore(state),
        actions: isAdmin ? Object.keys(ASSET_BATCH_ACTIONS) : [],
        isAdmin,
        batchActionsLoading: batchActionsSelectors.getBatchActionsLoading(state),
    };
};

const mapDispatchToProps = dispatch => ({
    onLoadMore: () =>
        dispatch({ type: assetConstants.LOAD_MORE_ASSETS_REQUEST }),
    onFetchTags: () => dispatch({ type: tagsConstants.FETCH_TAGS_REQUEST }),
    onBatchAction: (actionType, assets, additionalData) => {
        const action = ASSET_BATCH_ACTIONS[actionType];

        if (action) {
            dispatch({
                type: action,
                payload: { assets, additionalData }
            });
        }
    },
    onCreateExportJob: ({
        exportTables,
        exportCharts,
        format,
        selectedAssetsIds,
        withBackground,
    }) =>
        dispatch({
            type: assetConstants.EXPORT_PROJECT_IMAGES_REQUEST,
            payload: { exportTables, exportCharts, format, selectedAssetsIds, withBackground },
        }),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Assets);



// WEBPACK FOOTER //
// ./src/containers/BucketAssets.js